// Singapore locale formatters
export const SGD = (n, opts = {}) => {
  const { decimals = 0 } = opts;
  if (n === null || n === undefined || Number.isNaN(n)) return "S$0";
  const abs = Math.abs(n);
  const s = new Intl.NumberFormat("en-SG", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(abs);
  return n < 0 ? `-S$${s}` : `S$${s}`;
};

export const pct = (n, decimals = 2) => {
  if (n === null || n === undefined || Number.isNaN(n)) return "0%";
  return `${Number(n).toFixed(decimals)}%`;
};

export const num = (n, decimals = 0) => {
  if (n === null || n === undefined || Number.isNaN(n)) return "0";
  return new Intl.NumberFormat("en-SG", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(n);
};

// DD MMM YYYY
export const formatSGDate = (d) => {
  const date = d instanceof Date ? d : new Date(d);
  if (Number.isNaN(date.getTime())) return "";
  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("en-SG", { month: "short" });
  const year = date.getFullYear();
  return `${day} ${month} ${year}`;
};

export const monthsBetween = (fromDate, toDate) => {
  const from = fromDate instanceof Date ? fromDate : new Date(fromDate);
  const to = toDate instanceof Date ? toDate : new Date(toDate);
  const years = to.getFullYear() - from.getFullYear();
  const months = to.getMonth() - from.getMonth();
  const days = to.getDate() - from.getDate();
  return years * 12 + months + (days >= 0 ? 0 : -1);
};

export const yearsBetween = (fromDate, toDate) => monthsBetween(fromDate, toDate) / 12;
